import { render } from "./ProjectPage.vue?vue&type=template&id=43ff2856&scoped=true"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"

import "./ProjectPage.vue?vue&type=style&index=0&id=43ff2856&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ff2856"]])

export default __exports__